import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EmojiSupportService {
  readonly flagEmojiSupported: boolean;

  constructor() {
    this.flagEmojiSupported = this.supportsFlagEmoji();
    console.log('EMOJI SUPPORTED: ' + this.flagEmojiSupported);
  }

  /**
   * Returns the emoji flag for a given country code, or null if not supported or invalid.
   */
  getFlagEmoji(countryCode: string): string | null {
    if (!this.flagEmojiSupported) return null;

    const code = (countryCode || '').trim().toUpperCase();
    if (code.length < 2) return null;

    return Array.from(code.slice(0, 2))
      .map(c => String.fromCodePoint(c.charCodeAt(0) + 0x1F1A5))
      .join('');
  }

  /**
   * Detects whether the platform supports emoji flags.
   */
  private supportsFlagEmoji(): boolean {

    if (typeof document === 'undefined') {
      return false;
    }

    const canvas = document.createElement('canvas');
    canvas.width = 2;
    canvas.height = 2;
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      return false;
    }

    // When text is drawn on a canvas, the browser uses the context's `fillStyle`.
    // The default is black.
    // - If flags are NOT supported, the browser draws the letters 'U' and 'N' in black.
    // - If flags ARE supported, the browser ignores the `fillStyle` and draws the full-color emoji.
    ctx.fillText('🇺🇳', 0, 2);

    const imageData = ctx.getImageData(0, 0, 2, 2).data;

    // The pixel data is a flat array of [R, G, B, A, R, G, B, A, ...].
    // Black text would have R=0, G=0, B=0 for all its pixels.
    // A colorful emoji will have non-zero values for R, G, or B.
    for (let i = 0; i < imageData.length; i += 4) {
      const hasRed = imageData[i] > 0;
      const hasGreen = imageData[i + 1] > 0;
      const hasBlue = imageData[i + 2] > 0;

      // If we find any pixel that isn't black, it must be a color emoji.
      if (hasRed || hasGreen || hasBlue) {
        return true;
      }
    }

    // If we looped through all pixels and found no color, it's just the black text fallback.
    return false;
  }
}
